import Masker from 'vanilla-masker';

export default function toPersonDocument(document) {
  if (!document) return '-';
  const documentValue = String(document);
  if (documentValue.length === 11) {
    return Masker.toPattern(documentValue, '999.999.999-99');
  }
  if (documentValue.length === 14) {
    return Masker.toPattern(documentValue, '99.999.999/9999-99');
  }

  return '-';
}
